import React from 'react';
import { motion } from 'framer-motion';

const SectionContactCTA = () => (
  <section className="py-16 bg-gray-50 text-gray-800">
    <div className="container mx-auto px-4 text-center">
      <motion.h2 
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
        className="text-3xl font-bold mb-4 text-primary"
      >
        Need help with your application?
      </motion.h2>

      <motion.div 
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.7 }}
        viewport={{ once: true }}
        className="text-xl mb-8"
      >
        <p>Call us at <span className="font-bold text-primary">0425 625 605</span> or email <span className="font-bold text-primary">contact@jdpfinance.com.au</span></p>
      </motion.div>

      <motion.a 
        href="/contact-us"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.5 }}
        viewport={{ once: true }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="bg-secondary text-white font-bold py-3 px-8 rounded-lg text-xl shadow-lg hover:bg-secondary/90 transition-all duration-300 inline-block"
      >
        Contact Us
      </motion.a>
    </div>
  </section>
);

export default SectionContactCTA;
